import { render, staticRenderFns } from "./selectAccountSet.vue?vue&type=template&id=08b4aafd"
import script from "./selectAccountSet.vue?vue&type=script&lang=js"
export * from "./selectAccountSet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports